import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  EntityService,
  CollectionManagerService
} from '@zerops/zef/entities';
import { AppState, ApiEntityKeys } from '@zerops/zerops/app';
import { ZefWebsocketService } from '@zerops/zef/websocket';
import { TransactionCredit } from '@zerops/models/transaction-credit';
import { Sort } from '@zerops/zef/sort';

@Injectable({ providedIn: 'root' })
export class TransactionCreditEntity extends EntityService<TransactionCredit> {

  defaultSort: Sort = {
    key: 'createdDate',
    direction: 'desc'
  };

  list$(
    tag?: string | { name: string; id: string; },
    orderSelector: Array<string | ((i: TransactionCredit) => any)> = [ this.defaultSort.key ],
    orderDir: Array<boolean | 'asc' | 'desc'> = [ this.defaultSort.direction ]
  ) {
    return super.list$(tag, orderSelector, orderDir);
  }

  constructor(
    public store: Store<AppState>,
    public collectionManager: CollectionManagerService,
    public websocketTransactionCredit: ZefWebsocketService
  ) {
    super(ApiEntityKeys.TransactionCredit, store, collectionManager, websocketTransactionCredit);
  }
}
